export const data: any = {
  NEXT_PUBLIC_BASE_URL: "https://www.trimble.com",
  NEXT_PUBLIC_SITEMAP_BASE_URL: "https://www.trimble.com",
  NEXT_PUBLIC_SITE_MACHINE_NAME: "corporate",
  NEXT_PUBLIC_CF_MXP_SPACE_ID: "citn2sn5tdjr",
  NEXT_PUBLIC_GTM_ID: "GTM-TPFGGLT",
  NEXT_PUBLIC_ONETRUST_ID: "c4b867da-0106-4cc2-85ba-b4958ea10d7e",
  NEXT_PUBLIC_ALGOLIA_SITE_INDEX: "global-production",
  NEXT_PUBLIC_VWO_ACCOUNT_ID: "757115",
  NEXT_PUBLIC_DEPLOYMENT_ENV: "production"
}
